var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.line)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{staticClass:"ceo-verification"},[_c('span',[_vm._v(_vm._s(_vm.line.text))]),(_vm.line.stale)?_c('span',{staticClass:"ceo-verification__stale"},[_vm._v(" · "+_vm._s(_vm.$t(_vm.line.stale)))]):_vm._e()])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }